import { Input, Controller, Control, UseFormSetError } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import 'react-quill/dist/quill.snow.css';

import React from 'react';
import { useLazyQuery } from '@apollo/client';
import { RolesDocument } from 'src/graphql/generated/graphql';

interface NameFieldProps {
  control: Control<any, any, any>;
  errors?: Record<string, any>;
  setError: UseFormSetError<any>;
  roleId?: string;
}

export const NameField = ({
  control,
  errors,
  setError,
  roleId,
}: NameFieldProps) => {
  const { t } = useTranslation();
  const isOnblurHappenedRef = React.useRef(false);

  const [getRoles] = useLazyQuery(RolesDocument);

  const onBlur = async (event: React.FocusEvent<HTMLInputElement>) => {
    isOnblurHappenedRef.current = true;
  };

  const validate = async (value: string, a: any) => {
    if (!isOnblurHappenedRef.current) {
      return true;
    }

    const { data } = await getRoles({
      variables: {
        filter: {
          name: value,
        },
        pagination: {
          offset: 0,
          limit: 1,
        },
      },
    });
    const rolesWithName = data?.roles.records || [];

    if (rolesWithName.length && rolesWithName[0].id !== roleId) {
      setError('name', {
        type: 'custom',
        message: t('roles.errors.name-unique'),
      });
      return false;
    }
    return true;
  };

  return (
    <Controller
      name="name"
      control={control}
      rules={{ required: true, validate }}
      render={({ field }) => (
        <Input
          placeholder={t('common.name')}
          error={!!errors?.name}
          {...field}
          ref={undefined}
          inputRef={field.ref}
          value={undefined}
          defaultValue={field.value}
          onBlur={(event) => {
            onBlur(event as React.FocusEvent<HTMLInputElement>);
            field.onBlur();
          }}
        />
      )}
    />
  );
};
